(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["dropdown~index~table"],{

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "DropdownProps", function() { return /* reexport */ dropdown_DropdownProps; });
__webpack_require__.d(__webpack_exports__, "DropdownButtonProps", function() { return /* reexport */ DropdownButtonProps; });

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/base/vc-trigger/index.js + 9 modules
var vc_trigger = __webpack_require__(25);

// CONCATENATED MODULE: ./src/base/vc-dropdown/src/placements.js
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topCenter: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomCenter: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  }
};
/* harmony default export */ var src_placements = (placements);
// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./src/utils/vnode.js
var vnode = __webpack_require__(7);

// CONCATENATED MODULE: ./src/base/vc-dropdown/src/Dropdown.jsx
var _excluded = ["prefixCls", "transitionName", "animation", "align", "placement", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "trigger"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







/* harmony default export */ var Dropdown = ({
  mixins: [BaseMixin["a" /* default */]],
  props: {
    minOverlayWidthMatchTrigger: vue_types["a" /* default */].bool,
    prefixCls: vue_types["a" /* default */].string.def('rc-dropdown'),
    transitionName: vue_types["a" /* default */].string,
    overlayClassName: vue_types["a" /* default */].string.def(''),
    openClassName: vue_types["a" /* default */].string,
    animation: vue_types["a" /* default */].any,
    align: vue_types["a" /* default */].object,
    overlayStyle: vue_types["a" /* default */].object.def(function () {
      return {};
    }),
    placement: vue_types["a" /* default */].string.def('bottomLeft'),
    overlay: vue_types["a" /* default */].any,
    trigger: vue_types["a" /* default */].array.def(['hover']),
    alignPoint: vue_types["a" /* default */].bool,
    showAction: vue_types["a" /* default */].array.def([]),
    hideAction: vue_types["a" /* default */].array.def([]),
    getPopupContainer: vue_types["a" /* default */].func,
    visible: vue_types["a" /* default */].bool,
    clickNotClose: vue_types["a" /* default */].bool,
    defaultVisible: vue_types["a" /* default */].bool.def(false),
    mouseEnterDelay: vue_types["a" /* default */].number.def(0.15),
    mouseLeaveDelay: vue_types["a" /* default */].number.def(0.1)
  },
  data: function data() {
    var sVisible = this.defaultVisible;

    if (Object(props_util["hasProp"])(this, 'visible')) {
      sVisible = this.visible;
    }

    return {
      sVisible: sVisible
    };
  },
  watch: {
    visible: function visible(val) {
      if (val !== undefined) {
        this.setState({
          sVisible: val
        });
      }
    }
  },
  methods: {
    onClick: function onClick(e) {
      // // do no call onVisibleChange, if you need click to hide, use onClick and control visible
      if (!Object(props_util["hasProp"])(this, 'visible') && !Object(props_util["hasProp"])(this, 'clickNotClose')) {
        this.setState({
          sVisible: false
        });
        this.onVisibleChange(false);
      }

      this.$emit('overlayClick', e);

      if (this.childOriginEvents.click) {
        this.childOriginEvents.click(e);
      }
    },
    onVisibleChange: function onVisibleChange(visible) {
      if (!Object(props_util["hasProp"])(this, 'visible')) {
        this.setState({
          sVisible: visible
        });
      }

      this.__emit('visibleChange', visible);
    },
    getMinOverlayWidthMatchTrigger: function getMinOverlayWidthMatchTrigger() {
      var props = Object(props_util["getOptionProps"])(this);
      var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger,
          alignPoint = props.alignPoint;

      if ('minOverlayWidthMatchTrigger' in props) {
        return minOverlayWidthMatchTrigger;
      }

      return !alignPoint;
    },
    getOverlayElement: function getOverlayElement() {
      var overlay = this.overlay || this.$slots.overlay || this.$scopedSlots.overlay;
      var overlayElement;

      if (typeof overlay === 'function') {
        overlayElement = overlay();
      } else {
        overlayElement = overlay;
      }

      return overlayElement;
    },
    getMenuElement: function getMenuElement() {
      var _this = this;

      var onClick = this.onClick,
          prefixCls = this.prefixCls,
          $slots = this.$slots;
      this.childOriginEvents = Object(props_util["getEvents"])($slots.overlay[0]);
      var overlayElement = this.getOverlayElement();
      var extraOverlayProps = {
        props: {
          prefixCls: "".concat(prefixCls, "-menu"),
          getPopupContainer: function getPopupContainer() {
            return _this.getPopupDomNode();
          }
        },
        on: {
          click: onClick
        }
      };

      if (typeof overlayElement.type === 'string') {
        delete extraOverlayProps.props.prefixCls;
      }

      return Object(vnode["a" /* cloneElement */])($slots.overlay[0], extraOverlayProps);
    },
    getMenuElementOrLambda: function getMenuElementOrLambda() {
      var overlay = this.overlay || this.$slots.overlay || this.$scopedSlots.overlay;

      if (typeof overlay === 'function') {
        return this.getMenuElement;
      }

      return this.getMenuElement();
    },
    getPopupDomNode: function getPopupDomNode() {
      return this.$refs.trigger.getPopupDomNode();
    },
    getOpenClassName: function getOpenClassName() {
      var _this$$props = this.$props,
          openClassName = _this$$props.openClassName,
          prefixCls = _this$$props.prefixCls;

      if (openClassName !== undefined) {
        return openClassName;
      }

      return "".concat(prefixCls, "-open");
    },
    afterVisibleChange: function afterVisibleChange(visible) {
      if (visible && this.getMinOverlayWidthMatchTrigger()) {
        var overlayNode = this.getPopupDomNode();
        var rootNode = this.$el;

        if (rootNode && overlayNode && rootNode.offsetWidth > overlayNode.offsetWidth) {
          overlayNode.style.minWidth = "".concat(rootNode.offsetWidth, "px");

          if (this.$refs.trigger && this.$refs.trigger._component && this.$refs.trigger._component.$refs && this.$refs.trigger._component.$refs.alignInstance) {
            this.$refs.trigger._component.$refs.alignInstance.forceAlign();
          }
        }
      }
    },
    renderChildren: function renderChildren() {
      var children = this.$slots.default && this.$slots.default[0];
      var sVisible = this.sVisible;
      return sVisible && children ? Object(vnode["a" /* cloneElement */])(children, {
        class: this.getOpenClassName()
      }) : children;
    }
  },
  render: function render() {
    var h = arguments[0];

    var _this$$props2 = this.$props,
        prefixCls = _this$$props2.prefixCls,
        transitionName = _this$$props2.transitionName,
        animation = _this$$props2.animation,
        align = _this$$props2.align,
        placement = _this$$props2.placement,
        getPopupContainer = _this$$props2.getPopupContainer,
        showAction = _this$$props2.showAction,
        hideAction = _this$$props2.hideAction,
        overlayClassName = _this$$props2.overlayClassName,
        overlayStyle = _this$$props2.overlayStyle,
        trigger = _this$$props2.trigger,
        otherProps = _objectWithoutProperties(_this$$props2, _excluded);

    var triggerHideAction = hideAction;

    if (!triggerHideAction && trigger.indexOf('contextmenu') !== -1) {
      triggerHideAction = ['click'];
    }

    var triggerProps = {
      props: _objectSpread(_objectSpread({}, otherProps), {}, {
        prefixCls: prefixCls,
        popupClassName: overlayClassName,
        popupStyle: overlayStyle,
        builtinPlacements: src_placements,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction || [],
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: this.sVisible,
        afterPopupVisibleChange: this.afterVisibleChange,
        getPopupContainer: getPopupContainer
      }),
      on: {
        popupVisibleChange: this.onVisibleChange
      },
      ref: 'trigger'
    };
    return h(vc_trigger["a" /* default */], triggerProps, [this.renderChildren(), h("template", {
      slot: "popup"
    }, [this.$slots.overlay && this.getMenuElement()])]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-dropdown/src/index.js
// base in 2.4.1

/* harmony default export */ var vc_dropdown_src = (Dropdown);
// EXTERNAL MODULE: ./src/components/button/index.jsx + 2 modules
var components_button = __webpack_require__(40);

// CONCATENATED MODULE: ./src/components/dropdown/getDropdownProps.js

/* harmony default export */ var getDropdownProps = (function () {
  return {
    trigger: vue_types["a" /* default */].array.def(['hover']),
    overlay: vue_types["a" /* default */].any,
    visible: vue_types["a" /* default */].bool,
    disabled: vue_types["a" /* default */].bool,
    align: vue_types["a" /* default */].object,
    getPopupContainer: vue_types["a" /* default */].func,
    prefixCls: vue_types["a" /* default */].string,
    transitionName: vue_types["a" /* default */].string,
    clickNotClose: vue_types["a" /* default */].bool,
    placement: vue_types["a" /* default */].oneOf(['topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight']),
    overlayClassName: vue_types["a" /* default */].string,
    overlayStyle: vue_types["a" /* default */].object,
    forceRender: vue_types["a" /* default */].bool,
    mouseEnterDelay: vue_types["a" /* default */].number,
    mouseLeaveDelay: vue_types["a" /* default */].number,
    openClassName: vue_types["a" /* default */].string,
    minOverlayWidthMatchTrigger: vue_types["a" /* default */].bool
  };
});
// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// EXTERNAL MODULE: ./src/components/icon/index.jsx
var components_icon = __webpack_require__(41);

// CONCATENATED MODULE: ./src/components/dropdown/dropdown-button.jsx
var dropdown_button_excluded = ["type", "disabled", "htmlType", "prefixCls", "trigger", "align", "visible", "placement", "getPopupContainer", "href", "title"];

function dropdown_button_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = dropdown_button_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function dropdown_button_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function dropdown_button_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function dropdown_button_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { dropdown_button_ownKeys(Object(source), true).forEach(function (key) { dropdown_button_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { dropdown_button_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function dropdown_button_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 // import buttonTypes from '../button/buttonTypes';
// import { ButtonGroupProps } from '../button/group';






 // const ButtonTypesProps = buttonTypes();

var DropdownProps = getDropdownProps();
var ButtonGroup = components_button["default"].Group;

var DropdownButtonProps = dropdown_button_objectSpread(dropdown_button_objectSpread({}, DropdownProps), {}, {
  type: vue_types["a" /* default */].oneOf(['primary', 'ghost', 'dashed', 'danger', 'default']).def('default'),
  size: vue_types["a" /* default */].oneOf(['small', 'large', 'default']).def('default'),
  htmlType: vue_types["a" /* default */].oneOf(['button', 'submit', 'reset']).def('button'),
  href: vue_types["a" /* default */].string,
  disabled: vue_types["a" /* default */].bool,
  prefixCls: vue_types["a" /* default */].string,
  placement: DropdownProps.placement.def('bottomRight'),
  icon: vue_types["a" /* default */].any,
  title: vue_types["a" /* default */].string
});


/* harmony default export */ var dropdown_button = ({
  name: 'MegDropdownButton',
  model: {
    prop: 'visible',
    event: 'visibleChange'
  },
  props: DropdownButtonProps,
  provide: function provide() {
    return {
      savePopupRef: this.savePopupRef
    };
  },
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  methods: {
    savePopupRef: function savePopupRef(ref) {
      this.popupRef = ref;
    },
    onClick: function onClick(e) {
      this.$emit('click', e);
    },
    onVisibleChange: function onVisibleChange(val) {
      this.$emit('visibleChange', val);
    }
  },
  render: function render() {
    var h = arguments[0];

    var _this$$props = this.$props,
        type = _this$$props.type,
        disabled = _this$$props.disabled,
        htmlType = _this$$props.htmlType,
        customizePrefixCls = _this$$props.prefixCls,
        trigger = _this$$props.trigger,
        align = _this$$props.align,
        visible = _this$$props.visible,
        placement = _this$$props.placement,
        getPopupContainer = _this$$props.getPopupContainer,
        href = _this$$props.href,
        title = _this$$props.title,
        restProps = dropdown_button_objectWithoutProperties(_this$$props, dropdown_button_excluded);

    var icon = Object(props_util["getComponentFromProp"])(this, 'icon') || h(components_icon["default"], {
      attrs: {
        type: "ellipsis"
      }
    });
    var getContextPopupContainer = this.configProvider.getPopupContainer;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
    var dropdownProps = {
      props: {
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        placement: placement,
        getPopupContainer: getPopupContainer || getContextPopupContainer
      },
      on: {
        visibleChange: this.onVisibleChange
      }
    };

    if (Object(props_util["hasProp"])(this, 'visible')) {
      dropdownProps.props.visible = visible;
    }

    var buttonGroupProps = {
      props: dropdown_button_objectSpread({}, restProps),
      class: prefixCls
    };
    return h(ButtonGroup, buttonGroupProps, [h(components_button["default"], {
      attrs: {
        type: type,
        disabled: disabled,
        htmlType: htmlType,
        href: href,
        title: title
      },
      on: {
        "click": this.onClick
      }
    }, [this.$slots.default]), h(dropdown, dropdownProps, [h("template", {
      slot: "overlay"
    }, [Object(props_util["getComponentFromProp"])(this, 'overlay')]), h(components_button["default"], {
      attrs: {
        type: type
      }
    }, [icon])])]);
  }
});
// CONCATENATED MODULE: ./src/components/dropdown/dropdown.jsx
function dropdown_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function dropdown_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { dropdown_ownKeys(Object(source), true).forEach(function (key) { dropdown_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { dropdown_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function dropdown_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // import Icon from '../icon';

var dropdown_DropdownProps = getDropdownProps();
var dropdown_Dropdown = {
  name: 'MegDropdown',
  props: dropdown_objectSpread(dropdown_objectSpread({}, dropdown_DropdownProps), {}, {
    prefixCls: vue_types["a" /* default */].string,
    mouseEnterDelay: vue_types["a" /* default */].number.def(0.15),
    mouseLeaveDelay: vue_types["a" /* default */].number.def(0.1),
    placement: dropdown_DropdownProps.placement.def('bottomLeft')
  }),
  model: {
    prop: 'visible',
    event: 'visibleChange'
  },
  provide: function provide() {
    return {
      savePopupRef: this.savePopupRef
    };
  },
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  methods: {
    savePopupRef: function savePopupRef(ref) {
      this.popupRef = ref;
    },
    getTransitionName: function getTransitionName() {
      var _this$$props = this.$props,
          _this$$props$placemen = _this$$props.placement,
          placement = _this$$props$placemen === void 0 ? '' : _this$$props$placemen,
          transitionName = _this$$props.transitionName;

      if (transitionName !== undefined) {
        return transitionName;
      }

      if (placement.indexOf('top') >= 0) {
        return 'slide-down';
      }

      return 'slide-up';
    },
    renderOverlay: function renderOverlay(prefixCls) {
      var h = this.$createElement;
      var src = '';
      var dataSrc = 'prefix Class';
      var overlay = Object(props_util["getComponentFromProp"])(this, 'overlay');
      var overlayNode = Array.isArray(overlay) ? overlay[0] : overlay; // menu cannot be selectable in dropdown defaultly
      // menu should be focusable in dropdown defaultly

      var overlayProps = overlayNode && Object(props_util["getPropsData"])(overlayNode);

      var _ref = overlayProps || {},
          _ref$selectable = _ref.selectable,
          selectable = _ref$selectable === void 0 ? false : _ref$selectable,
          _ref$focusable = _ref.focusable,
          focusable = _ref$focusable === void 0 ? true : _ref$focusable;

      var expandIcon = h("span", {
        "class": "".concat(prefixCls, "-menu-submenu-arrow")
      }, [h("meg-icon", {
        attrs: {
          name: "megui-right"
        },
        "class": "".concat(prefixCls, "-menu-submenu-arrow-icon")
      })]);
      var fixedModeOverlay = overlayNode && overlayNode.componentOptions ? Object(vnode["a" /* cloneElement */])(overlayNode, {
        props: {
          mode: 'vertical',
          selectable: selectable,
          focusable: focusable,
          expandIcon: expandIcon
        }
      }) : overlay;
      return fixedModeOverlay;
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots;
    var props = Object(props_util["getOptionProps"])(this);
    var customizePrefixCls = props.prefixCls,
        trigger = props.trigger,
        disabled = props.disabled,
        getPopupContainer = props.getPopupContainer;
    var getContextPopupContainer = this.configProvider.getPopupContainer;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    var dropdownTrigger = Object(vnode["a" /* cloneElement */])($slots.default, {
      class: "".concat(prefixCls, "-trigger"),
      props: {
        disabled: disabled
      }
    });
    var triggerActions = disabled ? [] : trigger;
    var alignPoint;

    if (triggerActions && triggerActions.indexOf('contextmenu') !== -1) {
      alignPoint = true;
    }

    var dropdownProps = {
      props: dropdown_objectSpread(dropdown_objectSpread({
        alignPoint: alignPoint
      }, props), {}, {
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: this.getTransitionName(),
        trigger: triggerActions
      }),
      on: Object(props_util["getListeners"])(this)
    };
    return h(vc_dropdown_src, dropdownProps, [dropdownTrigger, h("template", {
      slot: "overlay"
    }, [this.renderOverlay(prefixCls)])]);
  }
};
dropdown_Dropdown.Button = dropdown_button;
/* harmony default export */ var dropdown = (dropdown_Dropdown);

// EXTERNAL MODULE: ./src/base/base/index.js
var base = __webpack_require__(19);

// CONCATENATED MODULE: ./src/components/dropdown/index.jsx




 // import './style/index.scss';

dropdown.Button = dropdown_button;
/* istanbul ignore next */

dropdown.install = function (Vue) {
  Vue.use(base["a" /* default */]);
  Vue.component(dropdown.name, dropdown);
  Vue.component(dropdown_button.name, dropdown_button);
};

/* harmony default export */ var components_dropdown = __webpack_exports__["default"] = (dropdown);

/***/ })

}]);